import React from 'react'
import PanelNav, { PanelNavProvider, PanelEnabled } from './PanelNav'
import { BenefitsBulletList, Testimonial, CoachChatFeature } from './components'
import { AylaPanel, WebinarPanel } from './commonPanels'
import useTranslation from '../../../shared/TranslationProvider'

const FlexBenefitsPanel = () => {
  const items = [...Array(6).keys()].map((key) => `RightPanel.flex.item${key}`)
  const { locale } = useTranslation()
  const isUsEnglish = locale === 'en'

  return (
    <>
      <PanelEnabled thisPanelNumber={0}>
        <PanelNav />
        <BenefitsBulletList items={items} />
        {isUsEnglish ? <CoachChatFeature /> : <Testimonial />}
      </PanelEnabled>
    </>
  )
}

const RightPanelFlex = () => {
  const { locale } = useTranslation()
  if (locale.slice(0, 2) === 'en') {
    return (
      <PanelNavProvider panelCount={3}>
        <FlexBenefitsPanel />
        <WebinarPanel />
        <AylaPanel />
      </PanelNavProvider>
    )
  } else {
    return (
      <PanelNavProvider panelCount={2}>
        <FlexBenefitsPanel />
        <AylaPanel thisPanelNumber={1} />
      </PanelNavProvider>
    )
  }
}

export default RightPanelFlex
